const nodeURL = process.env.REACT_APP_STRAPI_URL
const headers = () => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("accessToken")}`
})

export const fetchFeatureFlags = async () => {
    const opts = {
        method: 'GET',
        headers: headers()
    }

    const response = await fetch(`${nodeURL}/feature-flags`, opts);
    const data = await response.json();

    return data;
}